// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var Rect$SmartcutsMacros = require("../Rect.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("../Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../../bs-utils/src/PromiseUtils.bs.js");
var PlaybackModal$SmartcutsMacros = require("../app/PlaybackModal.bs.js");
var DevProtocol__DOM$SmartcutsMacros = require("./DevProtocol__DOM.bs.js");
var DevProtocol__Page$SmartcutsMacros = require("./DevProtocol__Page.bs.js");
var DevProtocol__Input$SmartcutsMacros = require("./DevProtocol__Input.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var DevProtocol__Runtime$SmartcutsMacros = require("./DevProtocol__Runtime.bs.js");
var DevProtocol__DOMDebugger$SmartcutsMacros = require("./DevProtocol__DOMDebugger.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../InterfaceBtwnRecordingAndPlayback.bs.js");

function getEventListenersForNodeId(tabId, nodeId) {
  return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function (maybeRemoteObject) {
              if (maybeRemoteObject === undefined) {
                return Promise.resolve([]);
              }
              var objectId = maybeRemoteObject.objectId;
              if (objectId !== undefined) {
                return DevProtocol__DOMDebugger$SmartcutsMacros.getEventListeners(objectId, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeListeners) {
                            if (maybeListeners !== undefined) {
                              return Promise.resolve(maybeListeners);
                            } else {
                              return Promise.resolve([]);
                            }
                          });
              } else {
                return Promise.resolve([]);
              }
            });
}

function fromNode(node) {
  return {
          TAG: /* BackendNodeId */1,
          _0: node.backendNodeId
        };
}

function describeNode(tabId, depth, node) {
  if (node.TAG === /* NodeId */0) {
    return DevProtocol__DOM$SmartcutsMacros.describeNode(node._0, undefined, undefined, depth, undefined, tabId, undefined, undefined, undefined);
  } else {
    return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, node._0, undefined, depth, undefined, tabId, undefined, undefined, undefined);
  }
}

function backendNodeIdGet(tabId, addCancelCallback, v) {
  if (v.TAG !== /* NodeId */0) {
    return Promise.resolve(v._0);
  }
  var nodeId = v._0;
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return describeNode(tabId, /* TreeDepth */{
                      _0: 1
                    }, v).then(function (maybeNode) {
                    return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expected to describeNode for nodeId " + String(nodeId), maybeNode).backendNodeId);
                  });
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

var NodeRepresentation = {
  fromNode: fromNode,
  describeNode: describeNode,
  backendNodeIdGet: backendNodeIdGet
};

function rectFromBoxModel(param) {
  var border = param.border;
  var y1 = border[1];
  var x1 = border[0];
  return {
          x: x1,
          y: y1,
          width: border[2] - x1,
          height: border[5] - y1
        };
}

function rectFromVisualViewport(param) {
  return {
          x: param.pageX,
          y: param.pageY,
          width: param.clientWidth,
          height: param.clientHeight
        };
}

function isChildOrPseudoElement(tabId, addCancelCallback, childrenOrPseudoElementsFromNode, possibleAncestorNode, possibleDescendantNodeRep) {
  var childrenOrPsuedoElements = Curry._1(childrenOrPseudoElementsFromNode, possibleAncestorNode);
  if (childrenOrPsuedoElements !== undefined) {
    if (ArrayUtils$SmartcutsMacros.isEmpty(childrenOrPsuedoElements)) {
      return Promise.resolve([
                  false,
                  []
                ]);
    } else {
      return backendNodeIdGet(tabId, addCancelCallback, possibleDescendantNodeRep).then(function (possibleDescendantBackendNodeId) {
                  var isPossibleDescendantIdOneOfTheChildren = $$Array.exists((function (childNode) {
                          return possibleDescendantBackendNodeId === childNode.backendNodeId;
                        }), childrenOrPsuedoElements);
                  return Promise.resolve([
                              isPossibleDescendantIdOneOfTheChildren,
                              childrenOrPsuedoElements
                            ]);
                });
    }
  } else {
    return Promise.resolve([
                false,
                []
              ]);
  }
}

function isDescendant(tabId, addCancelCallback, possibleAncestorNodeRep, possibleDescendantNodeRep) {
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return describeNode(tabId, /* EntireSubTree */0, possibleAncestorNodeRep).then(function (maybeAncestor) {
                      if (maybeAncestor === undefined) {
                        return Promise.resolve(false);
                      }
                      var node = Caml_option.valFromOption(maybeAncestor);
                      var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                            return isChildOrPseudoElement(tabId, addCancelCallback, (function (prim) {
                                            return Caml_option.undefined_to_opt(prim.children);
                                          }), node, possibleDescendantNodeRep).then(function (param) {
                                        var isChild = param[0];
                                        if (isChild) {
                                          return Promise.resolve(isChild);
                                        }
                                        var children = param[1];
                                        var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                              return isChildOrPseudoElement(tabId, addCancelCallback, (function (prim) {
                                                              return Caml_option.undefined_to_opt(prim.pseudoElements);
                                                            }), node, possibleDescendantNodeRep).then(function (param) {
                                                          if (param[0]) {
                                                            return Promise.resolve(true);
                                                          } else if (ArrayUtils$SmartcutsMacros.isEmpty(children)) {
                                                            return Promise.resolve(false);
                                                          } else {
                                                            return Promise.race($$Array.map((function (childNode) {
                                                                              var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                                                                    return isDescendant(tabId, addCancelCallback, {
                                                                                                TAG: /* NodeId */0,
                                                                                                _0: childNode.nodeId
                                                                                              }, possibleDescendantNodeRep);
                                                                                  });
                                                                              Curry._1(addCancelCallback, match[1]);
                                                                              return Curry._1(match[0], undefined);
                                                                            }), children));
                                                          }
                                                        });
                                            });
                                        Curry._1(addCancelCallback, match[1]);
                                        return Curry._1(match[0], undefined);
                                      });
                          });
                      Curry._1(addCancelCallback, match[1]);
                      return Curry._1(match[0], undefined);
                    }).catch(function (jsPromiseError) {
                    var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                    if (typeof jsExn !== "number") {
                      switch (jsExn.TAG | 0) {
                        case /* JsExn */0 :
                            if (Caml_obj.caml_equal(jsExn._0.message, "{\"code\":-32000,\"message\":\"Could not find node with given id\"}")) {
                              return Promise.resolve(false);
                            }
                            break;
                        case /* UnknownPromiseError */13 :
                            console.error(jsExn._0);
                            return Promise.resolve(false);
                        default:
                          
                      }
                    }
                    console.error(jsPromiseError);
                    return Promise.resolve(false);
                  });
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function getParentInDomTree(domTree, backendNodeId) {
  var match = domTree.children;
  var match$1 = domTree.shadowRoots;
  var exit = 0;
  var childrenNodes;
  var shadowRoots;
  if (match !== undefined) {
    var exit$1 = 0;
    if (match.length !== 0) {
      exit$1 = 3;
    } else {
      if (match$1 === undefined) {
        return ;
      }
      if (match$1.length === 0) {
        return ;
      }
      exit$1 = 3;
    }
    if (exit$1 === 3) {
      if (match$1 !== undefined && match$1.length !== 0) {
        if (match.length !== 0) {
          if (Belt_Array.some(match$1, (function (shadowRoot) {
                    return shadowRoot.backendNodeId === backendNodeId;
                  }))) {
            return Caml_option.some(domTree);
          }
          if (Belt_Array.some(match, (function (childNode) {
                    return childNode.backendNodeId === backendNodeId;
                  }))) {
            return Caml_option.some(domTree);
          }
          var parent = Util$SmartcutsMacros.shortcut((function (subTree) {
                  return getParentInDomTree(subTree, backendNodeId);
                }), match$1);
          if (parent !== undefined) {
            return Caml_option.some(Caml_option.valFromOption(parent));
          } else {
            return Util$SmartcutsMacros.shortcut((function (subTree) {
                          return getParentInDomTree(subTree, backendNodeId);
                        }), match);
          }
        }
        shadowRoots = match$1;
        exit = 2;
      } else {
        childrenNodes = match;
        exit = 1;
      }
    }
    
  } else {
    if (match$1 === undefined) {
      return ;
    }
    if (match$1.length === 0) {
      return ;
    }
    shadowRoots = match$1;
    exit = 2;
  }
  switch (exit) {
    case 1 :
        if (Belt_Array.some(childrenNodes, (function (childNode) {
                  return childNode.backendNodeId === backendNodeId;
                }))) {
          return Caml_option.some(domTree);
        } else {
          return Util$SmartcutsMacros.shortcut((function (subTree) {
                        return getParentInDomTree(subTree, backendNodeId);
                      }), childrenNodes);
        }
    case 2 :
        if (Belt_Array.some(shadowRoots, (function (shadowRoot) {
                  return shadowRoot.backendNodeId === backendNodeId;
                }))) {
          return Caml_option.some(domTree);
        } else {
          return Util$SmartcutsMacros.shortcut((function (subTree) {
                        return getParentInDomTree(subTree, backendNodeId);
                      }), shadowRoots);
        }
    
  }
}

function findNodeInDomTreeByNodeIdOrBackendNodeId(maybeNodeId, maybeBackendNodeId, domTree) {
  if (maybeBackendNodeId !== undefined) {
    if (maybeNodeId !== undefined) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected at either nodeId or backendNodeId specified when findNodeInDomTreeByNodeIdOrBackendNodeId()");
    }
    if (domTree.backendNodeId === maybeBackendNodeId) {
      return Caml_option.some(domTree);
    }
    var arg = maybeBackendNodeId;
    var partial_arg = function (eta) {
      return findNodeInDomTreeByNodeIdOrBackendNodeId(undefined, arg, eta);
    };
    return Belt_Option.flatMap(Caml_option.undefined_to_opt(domTree.children), (function (param) {
                  return ArrayUtils$SmartcutsMacros.shortcut(partial_arg, param);
                }));
  }
  if (maybeNodeId === undefined) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected at either nodeId or backendNodeId specified when findNodeInDomTreeByNodeIdOrBackendNodeId()");
  }
  if (domTree.nodeId === maybeNodeId) {
    return Caml_option.some(domTree);
  }
  var partial_arg$1 = maybeNodeId;
  var partial_arg$2 = function (eta) {
    var param;
    return findNodeInDomTreeByNodeIdOrBackendNodeId(partial_arg$1, param, eta);
  };
  return Belt_Option.flatMap(Caml_option.undefined_to_opt(domTree.children), (function (param) {
                return ArrayUtils$SmartcutsMacros.shortcut(partial_arg$2, param);
              }));
}

function closestAncestorNode(f, domTree, node) {
  return Curry._1(f, node).then(function (result) {
              if (result) {
                return Promise.resolve(Caml_option.some(node));
              }
              var backendNodeId = node.backendNodeId;
              var parent = getParentInDomTree(domTree, backendNodeId);
              if (parent !== undefined) {
                return closestAncestorNode(f, domTree, Caml_option.valFromOption(parent));
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function existsAncestorNode(f, domTree, node) {
  return closestAncestorNode(f, domTree, node).then(function (maybeAncestorNode) {
              return Promise.resolve(Belt_Option.isSome(maybeAncestorNode));
            });
}

function commonAncestorNode(tabId, domTree, addCancelCallback, nodeId1, nodeId2) {
  var nodeRep2 = {
    TAG: /* NodeId */0,
    _0: nodeId2
  };
  var node = findNodeInDomTreeByNodeIdOrBackendNodeId(nodeId1, undefined, domTree);
  if (node !== undefined) {
    return closestAncestorNode((function (node) {
                  return isDescendant(tabId, addCancelCallback, {
                              TAG: /* BackendNodeId */1,
                              _0: node.backendNodeId
                            }, nodeRep2);
                }), domTree, Caml_option.valFromOption(node));
  } else {
    return Promise.resolve(undefined);
  }
}

function doesEitherNodeContainEachOther(tabId, nodeId1, nodeId2, addCancelCallback) {
  return Belt_List.reduce({
              hd: [
                nodeId1,
                nodeId2
              ],
              tl: {
                hd: [
                  nodeId2,
                  nodeId1
                ],
                tl: /* [] */0
              }
            }, Promise.resolve(false), (function (promise_oneNodeIsDescendantOfTheOther, param) {
                var possibleAncestorNodeId = param[1];
                var possibleDescendantNodeId = param[0];
                return promise_oneNodeIsDescendantOfTheOther.then(function (oneNodeIsDescendantOfTheOther) {
                            if (oneNodeIsDescendantOfTheOther) {
                              return Promise.resolve(true);
                            } else {
                              return isDescendant(tabId, addCancelCallback, {
                                          TAG: /* NodeId */0,
                                          _0: possibleAncestorNodeId
                                        }, {
                                          TAG: /* NodeId */0,
                                          _0: possibleDescendantNodeId
                                        });
                            }
                          });
              }));
}

function getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
  return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, backendNodeId, objectId, undefined, undefined, tabId, extensionId, targetId, undefined).then(function (maybeNode) {
                return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, (function (prim) {
                                  return prim.nodeName;
                                })));
              }).then(function (maybeNodeName) {
              if (maybeNodeName !== undefined && maybeNodeName !== "SLOT") {
                return DevProtocol__DOM$SmartcutsMacros.getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, undefined).catch(function (jsPromiseError) {
                            var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                            if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */0 && Caml_obj.caml_equal(jsExn._0.message, "{\"code\":-32000,\"message\":\"Could not compute box model.\"}"))) {
                              return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
                            } else {
                              return Promise.resolve(undefined);
                            }
                          });
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function waitForNonNegativeBoxModel(timeout, interval, nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
  return Util$SmartcutsMacros.waitForPromise2(timeout, interval, (function (param) {
                return getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, undefined).then(function (maybeBoxModel) {
                            var arg = Belt_Option.map(maybeBoxModel, (function (boxModel) {
                                    var match = rectFromBoxModel(boxModel);
                                    if (match.x < 0 || match.y < 0) {
                                      return /* PredicateNotSatisfied */0;
                                    } else {
                                      return {
                                              TAG: /* PredicateSatisfied */0,
                                              _0: boxModel
                                            };
                                    }
                                  }));
                            return Promise.resolve((function (param) {
                                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                          })(/* PredicateNotSatisfied */0));
                          });
              }));
}

function isNodeVisible(tabId, addCancelCallback, nodeId) {
  return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                return getBoxModel(nodeId, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeBoxModel) {
                              if (maybeBoxModel !== undefined) {
                                return Promise.resolve(!(maybeBoxModel.width === 0 && maybeBoxModel.height === 0));
                              } else {
                                return Promise.resolve(false);
                              }
                            }).catch(function (jsPromiseError) {
                            var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                            if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */0 && Caml_obj.caml_equal(jsExn._0.message, "{\"code\":-32000,\"message\":\"Could not compute box model.\"}"))) {
                              return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
                            } else {
                              return Promise.resolve(false);
                            }
                          });
              }));
}

function getScrollHeight(tabId, backendNodeId) {
  return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeResult) {
                if (maybeResult === undefined) {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Expect to get Some(object) when resolveNode() to getScrollHeight()");
                }
                var objectId = OptionUtils$SmartcutsMacros.getExn("Expect to get Some(objectId)", maybeResult.objectId);
                return DevProtocol__Runtime$SmartcutsMacros.getProperties(objectId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (properties) {
                            console.warn("props for scrollHeight", properties);
                            return Promise.resolve(properties);
                          });
              }).then(function (maybeReturn) {
              if (maybeReturn !== undefined) {
                return Promise.resolve(Belt_Option.flatMap(Curry._2(DevProtocol__Runtime$SmartcutsMacros.GetProperties.Return.getPropertyValue, Caml_option.valFromOption(maybeReturn), "scrollHeight"), Js_json.decodeNumber));
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function getClientHeight(tabId, nodeId) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (maybeBoxModel) {
                if (maybeBoxModel !== undefined) {
                  return maybeBoxModel.height;
                }
                
              }), getBoxModel(nodeId, undefined, undefined, tabId, undefined, undefined, undefined));
}

function isNodeScrollable(tabId, node) {
  var nodeId = node.nodeId;
  var backendNodeId = node.backendNodeId;
  return Promise.all([
                getScrollHeight(tabId, backendNodeId),
                getClientHeight(tabId, nodeId)
              ]).then(function (param) {
              var maybeClientHeight = param[1];
              var maybeScrollHeight = param[0];
              if (maybeScrollHeight !== undefined && maybeClientHeight !== undefined) {
                return Promise.resolve(maybeScrollHeight > maybeClientHeight);
              } else {
                return Promise.resolve(false);
              }
            });
}

function scrollBy(tabId, nodeId, xOpt, yOpt, param) {
  var x = xOpt !== undefined ? xOpt : 0;
  var y = yOpt !== undefined ? yOpt : 0;
  if (x === 0 && y === 0) {
    return Promise.resolve(undefined);
  }
  return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function (maybeRemoteObject) {
              var arg = Belt_Option.flatMap(maybeRemoteObject, (function (param) {
                      return param.objectId;
                    }));
              var objectId = (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                  })("Expect to get Some({objectId: Some(objectId)}) as result of resolveNode() when try to scrollBy()");
              return DevProtocol__Runtime$SmartcutsMacros.callFunctionOn("Element.prototype.scrollBy", objectId, [
                            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(x),
                            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(y)
                          ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function ($$return) {
                          var exceptionDetails = $$return.exceptionDetails;
                          if (exceptionDetails !== undefined) {
                            Curry._2(Log$SmartcutsMacros.cdp.error2, "Exception when trying to scrollBy()", exceptionDetails);
                            return Promise.reject({
                                        RE_EXN_ID: DevProtocol__Runtime$SmartcutsMacros.Exception,
                                        _1: exceptionDetails
                                      });
                          } else {
                            return Promise.resolve(undefined);
                          }
                        });
            });
}

function scrollTo(tabId, nodeId, xOpt, yOpt, param) {
  var x = xOpt !== undefined ? xOpt : 0;
  var y = yOpt !== undefined ? yOpt : 0;
  return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function (maybeRemoteObject) {
              var arg = Belt_Option.flatMap(maybeRemoteObject, (function (param) {
                      return param.objectId;
                    }));
              var objectId = (function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                  })("Expect to get Some({objectId: Some(objectId)}) as result of resolveNode() when try to scrollTo()");
              return DevProtocol__Runtime$SmartcutsMacros.callFunctionOn("Element.prototype.scrollTo", objectId, [
                            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(x),
                            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(y)
                          ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function ($$return) {
                          var exceptionDetails = $$return.exceptionDetails;
                          if (exceptionDetails !== undefined) {
                            Curry._2(Log$SmartcutsMacros.cdp.error2, "Exception when trying to scrollTo()", exceptionDetails);
                            return Promise.reject({
                                        RE_EXN_ID: DevProtocol__Runtime$SmartcutsMacros.Exception,
                                        _1: exceptionDetails
                                      });
                          } else {
                            return Promise.resolve(undefined);
                          }
                        });
            });
}

function findOverlayRoot(tabId, addCancelCallback, sharedRoot, nodeIdOfElementAtPoint) {
  var nodeRepOfElementAtPoint = {
    TAG: /* NodeId */0,
    _0: nodeIdOfElementAtPoint
  };
  var loop = function (node) {
    var nodeId = node.nodeId;
    return isNodeVisible(tabId, addCancelCallback, nodeId).then(function (result) {
                if (result) {
                  return Promise.resolve(Caml_option.some(node));
                }
                var childrenNodes = node.children;
                if (childrenNodes !== undefined) {
                  return ArrayUtils$SmartcutsMacros.shortcutAsync((function (node) {
                                return isDescendant(tabId, addCancelCallback, {
                                              TAG: /* BackendNodeId */1,
                                              _0: node.backendNodeId
                                            }, nodeRepOfElementAtPoint).then(function (doesNodeContainElementAtPoint) {
                                            if (doesNodeContainElementAtPoint) {
                                              return loop(node);
                                            } else {
                                              return Promise.resolve(undefined);
                                            }
                                          });
                              }), childrenNodes);
                } else {
                  return Promise.resolve(undefined);
                }
              });
  };
  return loop(sharedRoot);
}

function clickPositionRelToElement(tabId, nodeId, positionRelToElement, modifiers, addCancelCallback, param) {
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback1, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return getBoxModel(nodeId, undefined, undefined, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(tabId), undefined, undefined, undefined).then(function (maybeBoxModel) {
                    if (maybeBoxModel === undefined) {
                      return Promise.resolve(false);
                    }
                    var match = positionRelToElement.parent;
                    var parentHeight = match.height;
                    var parentWidth = match.width;
                    var y = positionRelToElement.y;
                    var x = positionRelToElement.x;
                    var match$1 = maybeBoxModel.border;
                    var y1 = match$1[1];
                    var x1 = match$1[0];
                    var xRatio = parentWidth > 0 ? (
                        x > 0 ? x / parentWidth : 0.5
                      ) : 0.5;
                    var yRatio = parentHeight > 0 ? (
                        y > 0 ? y / parentHeight : 0.5
                      ) : 0.5;
                    var xRel = maybeBoxModel.width * xRatio;
                    var yRel = maybeBoxModel.height * yRatio;
                    var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function (param, isCanceled) {
                          if (isCanceled.contents) {
                            throw {
                                  RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                  Error: new Error()
                                };
                          }
                          var arg = x1 + xRel | 0;
                          var arg$1 = y1 + yRel | 0;
                          var dispatchMouseEvent = function (param, param$1, param$2) {
                            var func = Curry._7(DevProtocol__Input$SmartcutsMacros.dispatchMouseEvent, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(tabId), param, param$1, param$2, arg, arg$1, modifiers);
                            return function (param, param$1) {
                              return Curry._4(func, param, "left", param$1, 1);
                            };
                          };
                          return Curry._4(dispatchMouseEvent(undefined, undefined, "mousePressed")(undefined, undefined), undefined, undefined, undefined, undefined).then(function (param) {
                                        return Curry._4(dispatchMouseEvent(undefined, undefined, "mouseReleased")(undefined, undefined), undefined, undefined, undefined, undefined);
                                      }).then(function (param) {
                                      return Promise.resolve(true);
                                    });
                        });
                    Curry._1(addCancelCallback1, match$2[1]);
                    return Curry._1(match$2[0], undefined);
                  });
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function doesNodeMatchId(tabId, idToMatch, node) {
  var backendNodeId = node.backendNodeId;
  return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeResult) {
              if (maybeResult === undefined) {
                return Promise.resolve(false);
              }
              var objectId = maybeResult.objectId;
              if (objectId !== undefined) {
                return DevProtocol__Runtime$SmartcutsMacros.getProperties(objectId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeProperties) {
                            var id = Belt_Option.flatMap(Belt_Option.flatMap(maybeProperties, (function (properties) {
                                        return Curry._2(DevProtocol__Runtime$SmartcutsMacros.GetProperties.Return.getPropertyValue, properties, "id");
                                      })), Js_json.decodeString);
                            if (id !== undefined) {
                              return Promise.resolve(id === idToMatch);
                            } else {
                              return Promise.resolve(false);
                            }
                          });
              } else {
                return Promise.resolve(false);
              }
            });
}

function isElementTopZIndexAtLocation(tabId, nodeId, maybeRelPosition, addCancelCallback, param) {
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return Promise.all([
                      DevProtocol__Page$SmartcutsMacros.getLayoutMetrics(tabId, undefined, undefined, undefined),
                      waitForNonNegativeBoxModel(4000, Util$SmartcutsMacros.WaitFor.checkIntervalMs, nodeId, undefined, undefined, tabId, undefined, undefined, undefined)
                    ]).then(function (param) {
                    var waitForResult_boxModel = param[1];
                    var maybeLayoutMetrics = param[0];
                    console.warn("GOT LAYOUT AND BOX MODEL", maybeLayoutMetrics, waitForResult_boxModel);
                    if (maybeLayoutMetrics === undefined) {
                      return Promise.resolve(/* CannotGetLayoutMetricsOrBoxModelOfElement */1);
                    }
                    if (waitForResult_boxModel.TAG === /* Ok */0) {
                      var boxModel = waitForResult_boxModel._0;
                      switch (boxModel.TAG | 0) {
                        case /* PredicateDidResolveTo */0 :
                            var boxModel$1 = boxModel._0;
                            var height = boxModel$1.height;
                            var width = boxModel$1.width;
                            var visualViewportRect = rectFromVisualViewport(maybeLayoutMetrics.cssVisualViewport);
                            var pageY = visualViewportRect.y;
                            var pageX = visualViewportRect.x;
                            var elementBorderRect = rectFromBoxModel(boxModel$1);
                            var top = elementBorderRect.y;
                            var left = elementBorderRect.x;
                            console.warn("maybeRelPosition", maybeRelPosition);
                            var match;
                            if (maybeRelPosition !== undefined) {
                              var match$1 = maybeRelPosition.parent;
                              var parentHeight = match$1.height;
                              var parentWidth = match$1.width;
                              var y = maybeRelPosition.y;
                              var x = maybeRelPosition.x;
                              var xRatio = parentWidth > 0 ? (
                                  x > 0 ? x / parentWidth : 0.5
                                ) : 0.5;
                              var yRatio = parentHeight > 0 ? (
                                  y > 0 ? y / parentHeight : 0.5
                                ) : 0.5;
                              console.warn("xRatio", xRatio);
                              console.warn("yRatio", yRatio);
                              match = [
                                width * xRatio,
                                height * yRatio
                              ];
                            } else {
                              match = [
                                width / 2,
                                height / 2
                              ];
                            }
                            var yRel = match[1];
                            var xRel = match[0];
                            var x$1 = pageX + left + xRel;
                            console.warn("Calculating x", pageX, left, xRel);
                            var y$1 = pageY + top + yRel;
                            console.warn("Calculating y", pageY, top, yRel);
                            var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
                                  if (isCanceled.contents) {
                                    throw {
                                          RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                          Error: new Error()
                                        };
                                  }
                                  console.warn("GETTING NODE FOR LOCATION", x$1, y$1);
                                  return DevProtocol__DOM$SmartcutsMacros.getNodeForLocation(x$1 | 0, y$1 | 0, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeResult) {
                                              if (maybeResult === undefined) {
                                                return Promise.resolve(/* ElementNotInViewport */2);
                                              }
                                              var nodeId2 = maybeResult.nodeId;
                                              if (nodeId2 === undefined) {
                                                return Promise.resolve(/* ElementNotInViewport */2);
                                              }
                                              var isSameElement = nodeId2 === nodeId;
                                              if (isSameElement) {
                                                return Promise.resolve(/* ElementIsTopZIndexAtLocation */0);
                                              }
                                              var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                                    return doesEitherNodeContainEachOther(tabId, nodeId, nodeId2, addCancelCallback).then(function (eitherNodeContainsTheOther) {
                                                                if (eitherNodeContainsTheOther) {
                                                                  return Promise.resolve(/* ElementIsTopZIndexAtLocation */0);
                                                                } else {
                                                                  return DevProtocol__DOM$SmartcutsMacros.getDocument(/* EntireSubTree */0, true, tabId, undefined, undefined, undefined).then(function (maybeDomTree) {
                                                                              if (maybeDomTree === undefined) {
                                                                                return Promise.resolve(/* CannotGetDomTree */3);
                                                                              }
                                                                              var domTree = Caml_option.valFromOption(maybeDomTree);
                                                                              var checkOverlayIsPlaybackModal = function (param) {
                                                                                var overlayNode = findNodeInDomTreeByNodeIdOrBackendNodeId(nodeId2, undefined, domTree);
                                                                                if (overlayNode !== undefined) {
                                                                                  return existsAncestorNode((function (param) {
                                                                                                return doesNodeMatchId(tabId, PlaybackModal$SmartcutsMacros.PlaybackModal.containerId, param);
                                                                                              }), domTree, Caml_option.valFromOption(overlayNode));
                                                                                } else {
                                                                                  return Promise.resolve(false);
                                                                                }
                                                                              };
                                                                              return checkOverlayIsPlaybackModal(undefined).then(function (overlayIsPlaybackModal) {
                                                                                          if (overlayIsPlaybackModal) {
                                                                                            return Promise.resolve(/* HideSmartcutsPlaybackModalUntilCompletedCommand */8);
                                                                                          } else {
                                                                                            return commonAncestorNode(tabId, domTree, addCancelCallback, nodeId, nodeId2).then(function (maybeCommonAncestor) {
                                                                                                        if (maybeCommonAncestor === undefined) {
                                                                                                          return Promise.resolve(/* CannotFindOverlayRoot */5);
                                                                                                        }
                                                                                                        var ancestor = Caml_option.valFromOption(maybeCommonAncestor);
                                                                                                        return Promise.all([
                                                                                                                      closestAncestorNode((function (param) {
                                                                                                                              return isNodeScrollable(tabId, param);
                                                                                                                            }), domTree, ancestor),
                                                                                                                      findOverlayRoot(tabId, addCancelCallback, ancestor, nodeId2)
                                                                                                                    ]).then(function (param) {
                                                                                                                    var maybeOverlayRoot = param[1];
                                                                                                                    var maybeScrollRoot = param[0];
                                                                                                                    if (maybeScrollRoot === undefined) {
                                                                                                                      return Promise.resolve(/* CannotFindScrollRoot */6);
                                                                                                                    }
                                                                                                                    if (maybeOverlayRoot === undefined) {
                                                                                                                      return Promise.resolve(/* CannotFindOverlayRoot */5);
                                                                                                                    }
                                                                                                                    var scrollRoot = Caml_option.valFromOption(maybeScrollRoot);
                                                                                                                    return getBoxModel(undefined, Caml_option.valFromOption(maybeOverlayRoot).backendNodeId, undefined, tabId, undefined, undefined, undefined).then(function (maybeBoxModel) {
                                                                                                                                if (maybeBoxModel === undefined) {
                                                                                                                                  return Promise.resolve(/* CannotGetBoxModelOfOverlay */4);
                                                                                                                                }
                                                                                                                                var overlayBorderRect = rectFromBoxModel(maybeBoxModel);
                                                                                                                                var viewportTop = Rect$SmartcutsMacros.top(visualViewportRect);
                                                                                                                                var viewportBottom = Rect$SmartcutsMacros.bottom(visualViewportRect);
                                                                                                                                var viewportHeight = visualViewportRect.height;
                                                                                                                                var overlayTop = Rect$SmartcutsMacros.top(overlayBorderRect);
                                                                                                                                var overlayBottom = Rect$SmartcutsMacros.bottom(overlayBorderRect);
                                                                                                                                var overlayHeight = overlayBorderRect.height;
                                                                                                                                if (!(viewportTop <= overlayTop && viewportBottom >= overlayBottom && viewportHeight > overlayHeight)) {
                                                                                                                                  return Promise.resolve(/* CannotScrollToRevealElement */7);
                                                                                                                                }
                                                                                                                                var distanceToScroll;
                                                                                                                                if (viewportBottom - overlayBottom > overlayTop - viewportTop) {
                                                                                                                                  var elementTop = Rect$SmartcutsMacros.top(elementBorderRect);
                                                                                                                                  distanceToScroll = elementTop - overlayBottom;
                                                                                                                                } else {
                                                                                                                                  var elementBottom = Rect$SmartcutsMacros.bottom(elementBorderRect);
                                                                                                                                  distanceToScroll = overlayTop - elementBottom;
                                                                                                                                }
                                                                                                                                return Promise.resolve(/* ScrollToRevealElement */{
                                                                                                                                            _0: scrollRoot,
                                                                                                                                            _1: distanceToScroll
                                                                                                                                          });
                                                                                                                              });
                                                                                                                  });
                                                                                                      });
                                                                                          }
                                                                                        });
                                                                            });
                                                                }
                                                              });
                                                  });
                                              Curry._1(addCancelCallback, match[1]);
                                              return Curry._1(match[0], undefined);
                                            });
                                });
                            Curry._1(addCancelCallback, match$2[1]);
                            return Curry._1(match$2[0], undefined);
                        case /* TimedOut */1 :
                        case /* PredicateTimedOut */2 :
                            break;
                        
                      }
                    }
                    if (waitForResult_boxModel.TAG === /* Ok */0) {
                      return Promise.resolve(/* CannotGetLayoutMetricsOrBoxModelOfElement */1);
                    }
                    var promiseError = waitForResult_boxModel._0;
                    if (promiseError.TAG !== /* UncaughtPredicateError */0) {
                      return Util$SmartcutsMacros.logAndRaiseJsError("Error while waiting to get a non-negative box model");
                    }
                    console.error("Error while waiting to get a non-negative box model", promiseError._0);
                    return Util$SmartcutsMacros.logAndRaiseJsError("Error while waiting to get a non-negative box model");
                  });
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function getNodeIdFromBackendNodeId(tabId, backendNodeId, addCancelCallback) {
  return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (addCancelCallback) {
                return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function (maybeRemoteObject) {
                            if (maybeRemoteObject === undefined) {
                              return Promise.resolve(undefined);
                            }
                            var objectId = maybeRemoteObject.objectId;
                            if (objectId !== undefined) {
                              return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                                            return DevProtocol__DOM$SmartcutsMacros.requestNode(objectId, tabId, undefined, undefined, undefined).then(function (maybeNodeId) {
                                                        return Promise.resolve(maybeNodeId);
                                                      });
                                          }));
                            } else {
                              return Promise.resolve(undefined);
                            }
                          });
              }));
}

exports.getEventListenersForNodeId = getEventListenersForNodeId;
exports.NodeRepresentation = NodeRepresentation;
exports.rectFromBoxModel = rectFromBoxModel;
exports.rectFromVisualViewport = rectFromVisualViewport;
exports.isChildOrPseudoElement = isChildOrPseudoElement;
exports.isDescendant = isDescendant;
exports.getParentInDomTree = getParentInDomTree;
exports.findNodeInDomTreeByNodeIdOrBackendNodeId = findNodeInDomTreeByNodeIdOrBackendNodeId;
exports.closestAncestorNode = closestAncestorNode;
exports.existsAncestorNode = existsAncestorNode;
exports.commonAncestorNode = commonAncestorNode;
exports.doesEitherNodeContainEachOther = doesEitherNodeContainEachOther;
exports.getBoxModel = getBoxModel;
exports.waitForNonNegativeBoxModel = waitForNonNegativeBoxModel;
exports.isNodeVisible = isNodeVisible;
exports.getScrollHeight = getScrollHeight;
exports.getClientHeight = getClientHeight;
exports.isNodeScrollable = isNodeScrollable;
exports.scrollBy = scrollBy;
exports.scrollTo = scrollTo;
exports.clickPositionRelToElement = clickPositionRelToElement;
exports.doesNodeMatchId = doesNodeMatchId;
exports.isElementTopZIndexAtLocation = isElementTopZIndexAtLocation;
exports.getNodeIdFromBackendNodeId = getNodeIdFromBackendNodeId;
/* Log-SmartcutsMacros Not a pure module */
